import React from 'react';

import Modal from '../../Modal';

import { useUiStore } from '../../../store';

export default function DialogModal() {
  const isDialogModalVisible = useUiStore(
    (state) => state.isDialogModalVisible
  );
  const hideDialogModal = useUiStore((state) => state.hideDialogModal);
  const dialogModalData = useUiStore((state) => state.dialogModalData);

  return (
    <Modal
      isVisible={isDialogModalVisible}
      hideModal={hideDialogModal}
      title={dialogModalData.title}
      zIndex={1000}
    >
      <p className="mb-4 font-light text-gray-500 dark:text-gray-400">
        {dialogModalData.text}
      </p>

      <div className="flex justify-center items-center space-x-4">
        <button
          data-modal-toggle="deleteAlertModal"
          type="button"
          className="py-2 px-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
          onClick={() => {
            hideDialogModal();
            dialogModalData.onCancel();
          }}
        >
          No, cancel
        </button>
        <button
          type="submit"
          className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-500 dark:hover:bg-red-600 dark:focus:ring-red-900"
          onClick={() => {
            dialogModalData.onConfirm();
            hideDialogModal();
          }}
        >
          <svg
            aria-hidden="true"
            className="w-4 h-4 mr-1.5 -ml-1"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
              clipRule="evenodd"
            ></path>
          </svg>
          Yes, confirm delete
        </button>
      </div>
    </Modal>
  );
}
